<wsd-extended-card
  [loading]="!(documents$ | async)"
  [redirectTo]="['/organizations', organizationId, 'modify', 'constitution']"
  [expanded]="expanded"
  (sizeChanged)="sizeChanged.emit()"
  [title]="'DATA_PORTAL.POLICY_DOCUMENTS.TITLE' | translate">
  <div *ngIf="documents$ | async as data" class="p-grid p-nogutter p-dir-col policy-documents-holder">
    <div *ngFor="let document of data.content" class="p-col">
      <div class="p-grid p-nogutter align-center">
        <div [ngSwitch]="document.state" class="p-col shrink state">
          <div *ngSwitchCase="true">
            <i class="fa fa-check primary-color"></i>
          </div>
          <div *ngSwitchCase="false">
            <i class="fa fa-times text-danger"></i>
          </div>
          <div *ngSwitchDefault style="opacity: .5">
            <i class="fas fa-question"></i>
          </div>
        </div>
        <div class="p-col">
          {{ document.documentName }}
        </div>
      </div>
    </div>
  </div>
</wsd-extended-card>
